import styles from "./Panorama.module.css";
import React, { Suspense, useRef, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import Camera from './Camera';
import ImageSphere from './ImageSphere';
import PanoHotspots from './PanoHotspots';
import { useAppStore } from "../../hooks/store/useAppStore";
import {
     setTourSceneNewHotspotSelector,
  } from "../../hooks/store/setters";
  import { activeSceneSelector, sceneHotspotsSelector } from "../../hooks/store/getters";
import { hotspotInitialState, hotspotErrorInitialState } from "../../hooks/store/Types";
import { setTourSceneNewHotspotErrorSelector } from "../../hooks/store/setters";
import { VRButton } from './VRButton.js';
import { showHotspotModalSelector } from "../../hooks/store/getters";
import { pauseSceneAudioSelector } from "../../hooks/store/getters";
import { changeHotspotPositionSelector } from "../../hooks/store/getters";
import { setTourSceneHotspotSelector } from "../../hooks/store/setters";
import { setChangeHotspotPositionSelector } from "../../hooks/store/setters";

// const panoDetails = {
//     id: 1,
//     pan: 90,
//     tilt: -40,
//     zoom: null,
//     imageUrl: "https://s3-us-east-2.amazonaws.com/ve-dev/2bacb2e7-3b76-480f-b0d1-57af57756462.jpg",
//     cameraFree: true
// };

const Panorama = ({ viewMode=false }) => {

    const activeScene = useAppStore(activeSceneSelector);
    const setSceneNewHotspot = useAppStore(setTourSceneNewHotspotSelector);
    const hotspots = useAppStore(sceneHotspotsSelector);
    const setTourSceneNewHotspotError = useAppStore(setTourSceneNewHotspotErrorSelector);
    const showHotspotModal = useAppStore(showHotspotModalSelector);
    const pauseSceneAudio = useAppStore(pauseSceneAudioSelector);
    const changeHotspotPosition = useAppStore(changeHotspotPositionSelector);
    const setTourSceneHotspot = useAppStore(setTourSceneHotspotSelector);
    const setChangeHotspotPosition = useAppStore(setChangeHotspotPositionSelector);

    const { panoImage, audio, pan, tilt, cameraFree, zoom, id: panoId } = activeScene;
    // const { pan, tilt, cameraFree, zoom, id: panoId } = panoDetails;
    console.log('showhotspotmodel',showHotspotModal);
    
    useEffect(() => {
        return () => {
            // document.getElementById('VR_Enabler').innerHTML = ''
            document.getElementById('VRButton')?.remove()
        }
    }, [])

    useEffect(() => {
        let playAudio;
        if(audio.url && viewMode && !showHotspotModal && !pauseSceneAudio) {
            playAudio = new Audio(audio.url);
            playAudio.play();
        } else if(showHotspotModal && pauseSceneAudio ){
            playAudio && playAudio.pause();
        }

        return () => {
            playAudio && playAudio.pause();
        }
        // eslint-disable-next-line
    }, [activeScene, viewMode, showHotspotModal, pauseSceneAudio])
   
    
    const group = useRef(null);
    
    const addNewHotspot = ({x, y, z}) => {
       
        if(viewMode) return;
        
        if(changeHotspotPosition){
            setTourSceneHotspot({ position: {x, y, z} });
            setChangeHotspotPosition(false);
            return;
        }
        
        const newHotspot = {
           ...hotspotInitialState,
            position: {x, y, z}
        }
        setSceneNewHotspot({...newHotspot});
        setTourSceneNewHotspotError({...hotspotErrorInitialState})
    };
    
    
    return (
        <Canvas className={styles.canvasWrapper}
            gl={{ alpha: false }} 
            colorManagement={false} 
            vr={viewMode}
            onCreated={({ gl }) => viewMode && document.body.appendChild(VRButton.createButton(gl))}
        >
            <Suspense fallback={null}>
                <Camera
                    position={[0, 0, -0.1]} 
                    pan={pan} 
                    tilt={tilt} 
                    defaultZoom={zoom} 
                    panoId={panoId} 
                />
                
                <OrbitControls 
                    enableKeys={true} 
                    rotateSpeed={-1} 
                    enableZoom={!!cameraFree} 
                    enablePan={false} 
                    dampingFactor={0.1} 
                    enabled={!!cameraFree} 
                    minDistance={5} 
                    maxDistance={950} 
                />
                
                
                <group ref={group}>
                    <ImageSphere
                        url={panoImage.url} 
                        position={[0, 0, 0]} 
                        key={panoImage.url} 
                        addNewHotspot={addNewHotspot}
                    />
                    <PanoHotspots hotspots={hotspots} viewMode={viewMode} />
                </group>
            </Suspense>
        </Canvas>
    );
};

export default Panorama;